import { useQuery } from '@tanstack/react-query';
import { fetchBuildingAttachments } from '../services/buildingAttachmentsApi';
import { buildingAttachmentsKeys } from './queryKeys';
export function useBuildingAttachmentsQuery(buildingId) {
    return useQuery({
        queryKey: buildingAttachmentsKeys.list(buildingId),
        queryFn: () => fetchBuildingAttachments(buildingId)
    });
}
